import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IValidationErrorResponse, NewsRssFeedType, ValidationModule, ValidationType } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { ValidatorService } from './validator.service';

@Injectable({
    providedIn: 'root',
})
export class ValidatorServiceImpl implements ValidatorService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    validateRssFromUrl(type: ValidationType, module: ValidationModule, url: string, rssFeedType?: NewsRssFeedType): Observable<IValidationErrorResponse[]> {
        return this.store
            .select(environmentSelector)
            .pipe(
                switchMap((env) =>
                    this.http
                        .post(`${env.baseUrl}/cerberus/validators?type=${type}&module=${module}`, { url, newsRssFeedType: rssFeedType })
                        .pipe(map((response) => response as IValidationErrorResponse[])),
                ),
            );
    }
}

export const VALIDATOR_SERVICE = {
    provide: ValidatorService,
    useClass: ValidatorServiceImpl,
};
